import React from "react";
import { SvgIcon } from "@mui/material";

const Annotationsvg = () => {
  return (
    <SvgIcon>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        fill="#C3E7FF"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <rect
          x="19.6"
          y="12.8"
          transform="matrix(0.7071 -0.7071 0.7071 0.7071 -3.643 26.7817)"
          width="21.8"
          height="10"
        ></rect>
        <polygon points="17.5,30.8 25.3,30.1 18.2,23"></polygon>
        <rect
          x="38.6"
          y="3.2"
          transform="matrix(0.7075 -0.7067 0.7067 0.7075 5.9003 30.7194)"
          width="3"
          height="10"
        ></rect>
        <path d="M36.9,24.7v14.2c0,0.5-0.4,0.8-0.8,0.8H9c-0.5,0-0.8-0.4-0.8-0.8V11.9C8.2,11.4,8.6,11,9,11h14.8L28,6.8H9c-2.8,0-5,2.3-5,5v27.1c0,2.8,2.3,5,5,5h27.1c2.8,0,5-2.3,5-5V20.5L36.9,24.7z"></path>
      </svg>
    </SvgIcon>
  );
};

const Pointsvg = () => {
  return (
    <SvgIcon>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path
          d="M38,23.5c0.8-1.8,1.2-3.9,1.2-6c0-8.4-6.8-15.2-15.2-15.2c-8.4,0-15.2,6.8-15.2,15.2c0,2.1,0.4,4.2,1.2,6  c1.3,3.1,4.9,7.6,6.6,10.7l6.5,12c0.5,0.9,1.3,0.9,1.8,0l6.5-12C33.1,31,36.6,26.6,38,23.5z M24,24.8c-4,0-7.3-3.3-7.3-7.3  c0-4,3.3-7.3,7.3-7.3c4,0,7.3,3.3,7.3,7.3C31.3,21.5,28,24.8,24,24.8z"
          fill="#C3E7FF"
        ></path>
      </svg>
    </SvgIcon>
  );
};
const Textsvg = () => {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <path
          fill="#C3E7FF"
          d="M6 5.25C6 4.56 6.56 4 7.25 4h17.5c.69 0 1.25.56 1.25 1.25v3.5a1.25 1.25 0 1 1-2.5 0V6.5h-6.25v19h1.5a1.25 1.25 0 1 1 0 2.5h-5.5a1.25 1.25 0 1 1 0-2.5h1.5v-19H8.5v2.25a1.25 1.25 0 1 1-2.5 0v-3.5Z"
        />
      </svg>
    </SvgIcon>
  );
};
const Linesvg = () => {
  return (
    <SvgIcon>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path
          d="M37.4,35.9L11.8,10.4V5H5.1v6.8h5.4l25.7,25.7v5.3h6.8v-6.8H37.4z"
          fill="#C3E7FF"
        ></path>
        <path d="M7.2,7.1h2.5v2.5H7.2V7.1z" fill="#C3E7FF"></path>
        <path d="M40.8,40.6h-2.5v-2.5h2.5V40.6z" fill="#C3E7FF"></path>
      </svg>
    </SvgIcon>
  );
};

const Polygonsvg = () => {
  return (
    <SvgIcon>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <polygon
          points="18.8,37.5 10.1,31.6 10.1,43.2 12.4,40.2 15.6,46.5 19,44.3 15.4,38.2"
          fill="#C3E7FF"
        ></polygon>
        <path
          d="M47.1,11.8V5H40.3v2.6L7.1,4.4V0.7H0.4v6.8h5.5l6.1,9.9h-0.5v6.8h1.9l-2.5,5.5l1.8,1.2l3-6.7h2.6v-6.8h-3.8   L7.8,6.6l32.5,3.1v2L37.5,21h-2.3v6.8h2.1l3,12.3h-1.4v6.8h6.8v-6.8h-3.2l-3.1-12.3H42V21h-2.3l2.8-9.2H47.1z M16.1,22.1h-2.5v-2.5   h2.5V22.1z M5,5.3H2.5V2.8H5V5.3z M43.6,44.8h-2.5v-2.5h2.5V44.8z M39.9,25.7h-2.5v-2.5h2.5V25.7z M42.5,7.1H45v2.5h-2.5V7.1z"
          fill="#C3E7FF"
        ></path>
      </svg>
    </SvgIcon>
  );
};

const Rectanglesvg = () => {
  return (
    <SvgIcon>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <polygon
          points="12.5,39.2 4.2,33.5 4.2,44.5 6.4,41.7 9.5,47.7 12.8,45.6 9.3,39.8"
          fill="#C3E7FF"
        ></polygon>
        <path
          d="M46.5,6.9V0.3H40v2.2H9.3V0.3H2.8v6.6h1.3v25l1.9,1.3V6.9h3.3V4.4H40v2.4h2.3v29H40v2.7H14.1l2.9,1.9h23v1.9h6.6v-6.6h-2.3v-29H46.5z M7.3,4.8H4.8V2.3h2.4V4.8z M44.5,40.4H42v-2.4h2.4V40.4z M42,2.3h2.4v2.4H42V2.3z"
          fill="#C3E7FF"
        ></path>
      </svg>
    </SvgIcon>
  );
};

const Circlesvg = () => {
  return (
    <SvgIcon>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <polygon
          points="11.9,37.7 3.7,32.2 3.7,43 5.9,40.2 9,46.2 12.2,44.1 8.8,38.4"
          fill="#C3E7FF"
        ></polygon>
        <circle cx="22.5" cy="23.5" r="3.2" fill="#C3E7FF"></circle>
        <circle cx="43.7" cy="23.5" r="3.2" fill="#C3E7FF"></circle>
        <path
          d="M4.3,30.2c-0.8-2.1-1.2-4.3-1.2-6.7c0-10.9,8.8-19.7,19.7-19.7c9.2,0,16.9,6.3,19,14.8    c0.6-0.2,1.2-0.4,1.8-0.4c0.1,0,0.1,0,0.2,0C41.5,8.9,33,1.8,22.8,1.8c-11.9,0-21.7,9.7-21.7,21.7c0,1.7,0.2,3.3,0.6,4.9L4.3,30.2    z"
          fill="#C3E7FF"
        ></path>
        <path
          d="M41.8,28.4c-2.2,8.5-9.9,14.8-19,14.8c-3.9,0-7.6-1.2-10.7-3.2l2,3.4c2.7,1.2,5.6,1.8,8.7,1.8    c10.2,0,18.7-7,21-16.5c-0.1,0-0.1,0-0.2,0C43,28.7,42.4,28.6,41.8,28.4z"
          fill="#C3E7FF"
        ></path>
      </svg>
    </SvgIcon>
  );
};
const Printsvg = () => (
  <SvgIcon>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        d="M17 2C17.5523 2 18 2.44772 18 3V7H21C21.5523 7 22 7.44772 22 8V18C22 18.5523 21.5523 19 21 19H18V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V19H3C2.44772 19 2 18.5523 2 18V8C2 7.44772 2.44772 7 3 7H6V3C6 2.44772 6.44772 2 7 2H17ZM16 17H8V20H16V17ZM20 9H4V17H6V16C6 15.4477 6.44772 15 7 15H17C17.5523 15 18 15.4477 18 16V17H20V9ZM8 10V12H5V10H8ZM16 4H8V7H16V4Z"
        fill="rgba(195,231,255,1)"
      ></path>
    </svg>
  </SvgIcon>
);

const Clearsvg = () => {
  return (
    <SvgIcon>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="#C3E7FF"
          d="M7 21q-.825 0-1.413-.588T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.588 1.413T17 21H7ZM17 6H7v13h10V6ZM9 17h2V8H9v9Zm4 0h2V8h-2v9ZM7 6v13V6Z"
        />
      </svg>
    </SvgIcon>
  );
};
const Deletesvg = () => {
  return (
    <SvgIcon>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="#C3E7FF"
          d="M7 21q-.825 0-1.413-.588T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.588 1.413T17 21H7ZM17 6H7v13h10V6ZM9 17h2V8H9v9Zm4 0h2V8h-2v9ZM7 6v13V6Z"
        />
      </svg>
    </SvgIcon>
  );
};
const Minimizesvg = () => {
  return (
    <SvgIcon style={{ position: "relative", left: "17px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="#C3E7FF"
          d="M20.857 9.75a.75.75 0 1 0 0-1.5h-4.046l5.72-5.72a.75.75 0 0 0-1.061-1.06l-5.72 5.72V3.142a.75.75 0 0 0-1.5 0V9c0 .414.336.75.75.75h5.857Zm-17.714 4.5a.75.75 0 0 0 0 1.5h4.046l-5.72 5.72a.75.75 0 1 0 1.061 1.06l5.72-5.72v4.047a.75.75 0 1 0 1.5 0V15a.75.75 0 0 0-.75-.75H3.143Z"
        />
      </svg>
    </SvgIcon>
  );
};
const PopupSvg = ({ color }: { color: string }) => {
  return (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 303 73.37"
    >
      <defs></defs>
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <path
            style={{
              fill: "none",
              stroke: color,
              strokeMiterlimit: 10,
              strokeWidth: "3px",
            }}
            d="m301.5,4.5v44c0,1.66-1.35,3-3,3H37.12l-9.26,18.52-9.26-18.52H4.5c-1.66,0-3-1.34-3-3V4.5c0-1.66,1.34-3,3-3h294c1.65,0,3,1.34,3,3Z"
          />
          <path
            style={{
              fill: color,
              opacity: 0.5,
              strokeWidth: "0px",
            }}
            d="m301.5,4.5v44c0,1.66-1.35,3-3,3H37.12l-9.26,18.52-9.26-18.52H4.5c-1.66,0-3-1.34-3-3V4.5c0-1.66,1.34-3,3-3h294c1.65,0,3,1.34,3,3Z"
          />
        </g>
      </g>
    </svg>
  );
};
export {
  Annotationsvg,
  Pointsvg,
  Linesvg,
  Printsvg,
  Polygonsvg,
  Rectanglesvg,
  Circlesvg,
  Textsvg,
  Clearsvg,
  Deletesvg,
  Minimizesvg,
  PopupSvg,
};
